import * as Sentry from "@sentry/react";

function skipCapture(key) {
    return key?.startsWith('brendon.storeInformations.info') 
}

function t(key) {
    const parameters = [...arguments].slice(1);
    let string = window.resources?.[key.toLowerCase()] || key.toLowerCase();
    
    parameters.forEach((parameter, index) => {
       string = string.replace(`{${index}}`, parameter);
    });

    if (!window.resources?.[key.toLowerCase()]) {
        if (window.location?.host?.startsWith('localhost')) {
            console.log(`Missing resource: ${key}, captured: ${!skipCapture(key)}`);
        } else {
            if (!skipCapture(key)) {
                Sentry.captureMessage(`Missing resource: ${key}`);
            }
        }
    }
 
    return string
}

export const windowsResourceUpdate = (stringResources) => {
    const newResources = {}
    for (const [key, value] of Object.entries(stringResources)) {
        newResources[key.toLowerCase()] = value
    }
    window.resources = {...window.resources, ...newResources}
}

export default t;

